import React from "react"
import { Div, Text } from "atomize"
import { motion } from "framer-motion"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck } from "@fortawesome/free-solid-svg-icons"
import { theme } from "../settings/config"
import SchemaDrawing from "../lesson/schema/SchemaDrawing"
import { CourtIcon } from "../lesson/schema/ExerciseSchema"
import {
	SCHEMA_SURFACES,
	schemaSurfaceClass,
	useSchemaSurface,
} from "../lesson/schema/schemaSurface"

// Su che campo si disegnano gli schemi. Al posto della pastiglia, i tre
// campi piccoli: una superficie si sceglie guardandola, non leggendone il
// nome. Ognuno ha la sua classe, così si vedono tutti e tre insieme mentre
// il resto dell'app segue quello scelto, ed è pieno del suo colore fino ai
// bordi, come lo schema aperto: il campo ci sta sopra senza cornice.
// Come il tema vale per questo telefono o questo computer.
function SchemaSurfaceSelector() {
	const [surface, setSurface] = useSchemaSurface()
	const current = SCHEMA_SURFACES.find(option => option.id === surface)

	return (
		<>
			<Div d="flex" align="center" style={{ gap: "0.75rem" }}>
				<Div
					w="40px"
					h="40px"
					rounded="circle"
					bg={theme.colors.gray_light}
					textColor={theme.colors.text_light}
					d="flex"
					align="center"
					justify="center"
					style={{ flexShrink: 0 }}>
					<CourtIcon />
				</Div>
				<Div>
					<Text textWeight="bold" textSize="subheader">
						Superficie degli schemi
					</Text>
					<Text textSize="caption" textColor={theme.colors.text_light}>
						Gli schemi si disegnano {current.on}
					</Text>
				</Div>
			</Div>

			<div
				role="group"
				aria-label="Superficie degli schemi"
				style={{
					display: "grid",
					gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
					gap: "0.5rem",
					marginTop: "0.75rem",
				}}>
				{SCHEMA_SURFACES.map(option => {
					const isSelected = option.id === surface
					return (
						<motion.button
							key={option.id}
							type="button"
							className={schemaSurfaceClass(option.id)}
							aria-pressed={isSelected}
							whileTap={{ scale: 0.96 }}
							onClick={() => setSurface(option.id)}
							style={{
								position: "relative",
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								gap: "0.125rem",
								minWidth: 0,
								padding: "0.25rem 0.25rem 0.625rem",
								border: 0,
								borderRadius: "15px",
								background: theme.colors.schema_court,
								// l'anello sta fuori, staccato dal colore del campo
								boxShadow: isSelected
									? `0 0 0 2px ${theme.colors.surface}, 0 0 0 4px ${theme.colors.primary}`
									: "none",
								color: theme.colors.white,
								textShadow: `0 1px 2px ${theme.colors.schema_shade}`,
								font: "inherit",
								fontSize: "0.75rem",
								fontWeight: 600,
								cursor: "pointer",
								transition: "box-shadow 0.15s",
							}}>
							<span
								aria-hidden="true"
								style={{ display: "block", width: "100%", aspectRatio: "358 / 400" }}>
								<SchemaDrawing schema={null} label="" grass={false} />
							</span>
							{option.label}
							{isSelected && (
								<span
									aria-hidden="true"
									style={{
										position: "absolute",
										top: "0.375rem",
										right: "0.375rem",
										width: "1.25rem",
										height: "1.25rem",
										borderRadius: "50%",
										background: theme.colors.primary,
										color: theme.colors.white,
										display: "inline-flex",
										alignItems: "center",
										justifyContent: "center",
										fontSize: "0.625rem",
										boxShadow: `0 1px 3px ${theme.colors.schema_shadow}`,
									}}>
									<FontAwesomeIcon icon={faCheck} />
								</span>
							)}
						</motion.button>
					)
				})}
			</div>
		</>
	)
}

export default SchemaSurfaceSelector
